export const LANGUAGES = [
  "English", "Tamil", "Hindi", "Telugu", "Kannada", "Malayalam", "Bengali",
  "Marathi", "Gujarati", "Punjabi", "Urdu", "Spanish", "French", "German",
  "Portuguese", "Italian", "Arabic", "Japanese", "Korean", "Mandarin Chinese",
];

export const ART_STYLES = [
  "Cinematic 3D Film",
  "Commercial Ad Vibe",
  "Whimsical Watercolor",
  "Traditional Indian Folk Art",
  "Minimalist Tech",
];

export const OUTPUT_OPTIONS = [
  {
    key: "movie",
    label: "Cinematic Short Film / Movie",
    desc: "Multi-scene script, storyboard frames, voiceover & subtitles",
    accent: "#3B82F6",
    icon: "Clapperboard",
  },
  {
    key: "campaign",
    label: "Growth Marketing Campaign",
    desc: "Ad copy, social threads, landing page text & banner art",
    accent: "#22C55E",
    icon: "Megaphone",
  },
  {
    key: "storybook",
    label: "Illustrated Storybook",
    desc: "Bilingual text, phonetics & narrated illustrated reader",
    accent: "#A855F7",
    icon: "BookOpen",
  },
];

export const OUTPUT_META = {
  movie: { label: "Movie", color: "#3B82F6", icon: "Clapperboard" },
  campaign: { label: "Campaign", color: "#22C55E", icon: "Megaphone" },
  storybook: { label: "Storybook", color: "#A855F7", icon: "BookOpen" },
};
